import { render } from "./VtoPageCatalog.vue?vue&type=template&id=61d2931c"
import script from "./VtoPageCatalog.vue?vue&type=script&lang=js"
export * from "./VtoPageCatalog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__